/** Class category of an ordered package (see App\Enums\PackageTypes). */
export class ClassCategory {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
  }

  /**
   * Map to readable.
   * @param {ClassCategory} classCategory Class category.
   * @returns {string}
   */
  static toReadable(classCategory) {
    return classCategory.name;
  }
}

export const ORDER_CLASS_CATEGORY = {
  FoodHandler: new ClassCategory({ id: 'food_handler', name: 'Food Handler' }),
  FoodManagerClass: new ClassCategory({ id: 'food_manager', name: 'Food Manager Class' }),
  ExamType: new ClassCategory({ id: 'exam', name: 'Exam' }),
};

export const ORDER_CLASS_CATEGORIES = Object.values(ORDER_CLASS_CATEGORY);
